function selectStyler() {

    var select = $('.select');

    if (select.length) {
        select.each(function(){
            if ( $(this).find('.jq-selectbox').length ) {
                $(this).find('select').trigger('refresh');
            }
            else {
                $(this).find('select').styler({
                    selectSmartPositioning : false,
                    selectSearch           : true,
                    selectSearchLimit      : 10
                });
            }
        });
    }

}